import React, { useState, useEffect, useContext, useRef } from "react";
import { useParams, withRouter } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import { useSelector, useDispatch } from "react-redux";
import ProgressBar from "react-bootstrap/ProgressBar";
import { ExternalUserContext } from "../../Context/externalUserContext";
import { previewResume } from "../../Store/Actions/ResumeActions";
import { RESUME_PREVIEW_RESET } from "../../Store/Constants/ResumeConstants";
import { COVER_DOWNLOAD_RESET } from "../../Store/Constants/CoverLetterConstants";
import "./DownloadPopup.scss";
import { downloadCover } from "../../Store/Actions/CoverLetterActions";
import { saveAs } from "file-saver";
import {
  AlignmentType,
  Document,
  HeadingLevel,
  Packer,
  Paragraph,
  TabStopPosition,
  TabStopType,
  TextRun,
} from "docx";
import axios from "axios";
function DownloadPopup(props) {
  const dispatch = useDispatch();
  const { id } = useParams();

  const [isProgress, setIsProgress] = useState(false);
  const [isProgressError, setIsProgressError] = useState(false);
  const [isProgressStop, setIsProgressStop] = useState(false);
  const [progressValue, setProgressValue] = useState(0);
  const [showLogin, setShowLogin] = useState(false);
  const [isEmailSuccess, setIsEmailSuccess] = useState(false);
  const [isEmail, setIsEmail] = useState(false);
  const [downloadKey, setDownloadKey] = useState("");

  const { isLogin, setIsLogin } = useContext(ExternalUserContext);

  const previewResumeData = useSelector((state) => state.resumePreview);
  const coverDownload = useSelector((state) => state.coverDownload);

  const resumeDownload = () => {
    let resumeId;
    if (typeof id === undefined || typeof id === "undefined") {
      resumeId = props.id;
    } else {
      resumeId = id;
    }

    if (isLogin && isLogin) {
      if (props.type == "resume") {
        dispatch(previewResume(resumeId));
      } else {
        dispatch(downloadCover(resumeId));
      }
      setIsProgress(true);
      setProgressValue(progressValue + 10);
    } else {
      setShowLogin(true);
    }
  };

  const resumeDownloadMail = () => {
    setIsEmail(true);
    let resumeId;
    if (typeof id === undefined || typeof id === "undefined") {
      resumeId = props.id;
    } else {
      resumeId = id;
    }
    if (isLogin && isLogin) {
      if (props.type == "resume") {
        dispatch(previewResume(resumeId, "download"));
      } else {
        dispatch(downloadCover(resumeId, "download"));
      }
      setIsProgress(true);
      setProgressValue(progressValue + 10);
    } else {
      setShowLogin(true);
    }
  };
  //For Cover
  useEffect(() => {
    if (coverDownload && coverDownload.error) {
      setIsProgressError(true);
      setIsProgress(false);
    } else {
      if (coverDownload && coverDownload.data && coverDownload.data.key) {
        setIsProgressStop(true);
        setDownloadKey(
          coverDownload && coverDownload.data && coverDownload.data.key
        );
        setProgressValue(100);

        if (
          coverDownload &&
          coverDownload.data &&
          coverDownload.data.pdf == "false"
        ) {
          setIsProgressStop(true);
          setProgressValue(100);

          var windowReference = window.open();
          windowReference.location = coverDownload.data.key;
          // window.open(
          //   previewResumeData.data.key,
          //   "_blank",
          //   "noopener,noreferrer"
          // );
        } else {
          const linkSource = `data:application/pdf;base64,${coverDownload.data.pdf}`;
          const link = document.createElement("a");
          link.href = linkSource;
          link.download =
            coverDownload && coverDownload.data && coverDownload.data.name;
          link.click();
        }

        //   dispatch({ type: COVER_DOWNLOAD_RESET });
      } else if (
        coverDownload &&
        coverDownload.data &&
        coverDownload.data.data &&
        coverDownload.data.data.pdf_sent
      ) {
        setIsEmailSuccess(true);
        setProgressValue(100);
      }
    }
  }, [coverDownload]);

  //For Resume
  useEffect(() => {
    if (previewResumeData && previewResumeData.error) {
      setIsProgressError(true);
      setIsProgress(false);
    } else {
      if (
        previewResumeData &&
        previewResumeData.data &&
        previewResumeData.data.key
      ) {
        setIsProgressStop(true);
        setProgressValue(100);
        setDownloadKey(
          previewResumeData &&
            previewResumeData.data &&
            previewResumeData.data.key
        );
        //   props.handleToggle();
        if (
          previewResumeData &&
          previewResumeData.data &&
          previewResumeData.data.pdf == "false"
        ) {
          setIsProgressStop(true);
          setProgressValue(100);

          var windowReference = window.open();
          windowReference.location = previewResumeData.data.key;
          // window.open(
          //   previewResumeData.data.key,
          //   "_blank",
          //   "noopener,noreferrer"
          // );
        } else {
          const linkSource = `data:application/pdf;base64,${previewResumeData.data.pdf}`;
          const link = document.createElement("a");
          link.href = linkSource;
          link.download =
            previewResumeData &&
            previewResumeData.data &&
            previewResumeData.data.name;
          link.click();
        }

        //   dispatch({ type: RESUME_PREVIEW_RESET });
      } else if (
        previewResumeData &&
        previewResumeData.data &&
        previewResumeData.data.data &&
        previewResumeData.data.data.pdf_sent
      ) {
        setIsEmailSuccess(true);
        setProgressValue(100);
        //   dispatch({ type: RESUME_PREVIEW_RESET });
      } else if (
        previewResumeData &&
        previewResumeData.data &&
        previewResumeData.data.data &&
        !previewResumeData.data.data.success
      ) {
        setIsProgressError(true);
        setIsProgress(false);
      }
    }
  }, [previewResumeData]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setProgressValue((prev) => {
        if (prev + 10 >= 100) {
          clearInterval(intervalId);
          if (progressValue == 100) {
            return 100;
          } else {
            return 90;
          }
        } else {
          return prev + 10;
        }
      });
    }, 2000);
    return () => clearInterval(intervalId);
  }, [progressValue]);

  const handleHide = () => {
    dispatch({ type: RESUME_PREVIEW_RESET });
    dispatch({ type: COVER_DOWNLOAD_RESET });

    setIsEmail(false);
    setDownloadKey("");
    setIsEmailSuccess(false);
    setIsProgress(false);
    setProgressValue(0);
    props.handleToggle();
  };
  const handleDownload = () => {
    var windowReference = window.open();
    windowReference.location = downloadKey && downloadKey;
    // window.open(downloadKey && downloadKey, "_blank", "noopener,noreferrer");
  };
  const experiences = [
    {
      isCurrent: true,
      summary:
        "Full-stack developer working with Angular and Java. Working for the iShares platform",
      title: "Associate Software Developer",
      startDate: {
        month: 11,
        year: 2017,
      },
      company: {
        name: "BlackRock",
      },
    },
    {
      isCurrent: false,
      summary:
        "Full-stack developer working with Angular, Node and TypeScript. Working for the iShares platform. Emphasis on Dev-ops and developing the continous integration pipeline.",
      title: "Software Developer",
      endDate: {
        month: 11,
        year: 2017,
      },
      startDate: {
        month: 10,
        year: 2016,
      },
      company: {
        name: "Torch Markets",
      },
    },
    {
      isCurrent: false,
      summary:
        "Used ASP.NET MVC 5 to produce a diversity data collection tool for the future of British television.\n\nUsed AngularJS and C# best practices. Technologies used include JavaScript, ASP.NET MVC 5, SQL, Oracle, SASS, Bootstrap, Grunt.",
      title: "Software Developer",
      endDate: {
        month: 10,
        year: 2016,
      },
      startDate: {
        month: 3,
        year: 2015,
      },
      company: {
        name: "Soundmouse",
      },
    },
    {
      isCurrent: false,
      summary:
        "Develop web commerce platforms for constious high profile clients.\n\nCreated a log analysis web application with the Play Framework in Java, incorporating Test Driven Development. It asynchronously uploads and processes large (2 GB) log files, and outputs meaningful results in context with the problem. \n\nAnalysis  and  development  of  the payment system infrastructure and user accounts section to be used by several clients of the company such as Waitrose, Tally Weijl, DJ Sports, Debenhams, Ann Summers, John Lewis and others.\n\nTechnologies used include WebSphere Commerce, Java, JavaScript and JSP.",
      title: "Java Developer",
      endDate: {
        month: 10,
        year: 2014,
      },
      startDate: {
        month: 3,
        year: 2013,
      },
      company: {
        name: "Soundmouse",
      },
    },
  ];

  const educations = [
    {
      degree: "Master of Science (MSc)",
      fieldOfStudy: "Computer Science",
      notes:
        "Exam Results: 1st Class with Distinction, Dissertation: 1st Class with Distinction\n\nRelevant Courses: Java and C# Programming, Software Engineering, Artificial Intelligence, \nComputational Photography, Algorithmics, Architecture and Hardware.\n\nCreated a Windows 8 game in JavaScript for the dissertation. \n\nCreated an award-winning 3D stereoscopic game in C# using XNA.",
      schoolName: "University College London",
      startDate: {
        year: 2012,
      },
      endDate: {
        year: 2013,
      },
    },
    {
      degree: "Bachelor of Engineering (BEng)",
      fieldOfStudy: "Material Science and Engineering",
      notes:
        "Exam Results: 2:1, Dissertation: 1st Class with Distinction\n\nRelevant courses: C Programming, Mathematics and Business for Engineers.",
      schoolName: "Imperial College London",
      startDate: {
        year: 2009,
      },
      endDate: {
        year: 2012,
      },
    },
  ];

  const skills = [
    {
      name: "Angular",
    },
    {
      name: "TypeScript",
    },
    {
      name: "JavaScript",
    },
    {
      name: "NodeJS",
    },
  ];
  const achievements = [
    {
      issuer: "Oracle",
      name: "Oracle Certified Expert",
    },
  ];
  const resumeWordDownload = async () => {
    // Fetch the document from the backend
    axios
      .post(
        `https://vrb-uat.qwikresume.com/review/api/word/convertToWord`,
        props.resumedata,
        {
          responseType: "blob", // Set the response type to 'blob' to receive binary data
          headers: {
            "Access-Control-Allow-Origin": "*", // Set the appropriate CORS header
          },
        }
      )
      .then((response) => {
        // Create a blob from the response data
        const blob = new Blob([response.data], {
          type: response.headers["content-type"],
        });

        // Create a URL for the blob
        const url = window.URL.createObjectURL(blob);

        // Create a link element and click it to trigger the download
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "document.docx");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((error) => {
        console.error("Error downloading document:", error);
      });
    // let data = props.resumedata;
    // const NAME = data?.profile?.data?.[0]?.name;
    // const JOBTITLE = data?.profile?.data?.[0]?.jobTitle;
    // const PHONE_NUMBER = "07534563401";
    // const PROFILE_URL = "https://www.linkedin.com/in/dolan1";
    // const EMAIL = "docx@docx.com";
    // const document = new Document({
    //   sections: [
    //     {
    //       children: [
    //         new Paragraph({
    //           text: NAME,
    //           heading: HeadingLevel.TITLE,
    //         }),
    //         new Paragraph({
    //           text: JOBTITLE,
    //           heading: HeadingLevel.HEADING_1,
    //         }),
    //         createContactInfo(
    //           data?.profile?.data?.[0],
    //           PHONE_NUMBER,
    //           PROFILE_URL,
    //           EMAIL
    //         ),
    //         // Conditionally add Education section
    //         ...(data &&
    //         data.education &&
    //         data.education.data &&
    //         data.education.data.length > 0
    //           ? [
    //               createHeading("Education"),
    //               ...(data &&
    //                 data.education &&
    //                 data.education.data &&
    //                 data.education.data
    //                   .map((education) => {
    //                     const arr = [];
    //                     arr.push(
    //                       createInstitutionHeader(
    //                         education.degree,
    //                         `${education.dateRange.fromMonth} - ${education.dateRange.fromYear}`
    //                       )
    //                     );
    //                     arr.push(
    //                       createRoleText(
    //                         `${education.school} - ${education.location}`
    //                       )
    //                     );
    //                     const bulletPoints = splitParagraphIntoBullets(
    //                       education.description
    //                     );
    //                     bulletPoints.forEach((bulletPoint) => {
    //                       arr.push(createBullet(bulletPoint));
    //                     });
    //                     return arr;
    //                   })
    //                   .reduce((prev, curr) => prev.concat(curr), [])),
    //             ]
    //           : []),
    //         createHeading("Experience"),
    //         ...experiences
    //           .map((position) => {
    //             const arr = [];
    //             arr.push(
    //               createInstitutionHeader(
    //                 position.company.name,
    //                 createPositionDateText(
    //                   position.startDate,
    //                   position.endDate,
    //                   position.isCurrent
    //                 )
    //               )
    //             );
    //             arr.push(createRoleText(position.title));
    //             const bulletPoints = splitParagraphIntoBullets(
    //               position.summary
    //             );
    //             bulletPoints.forEach((bulletPoint) => {
    //               arr.push(createBullet(bulletPoint));
    //             });
    //             return arr;
    //           })
    //           .reduce((prev, curr) => prev.concat(curr), []),
    //         createHeading("Skills, Achievements and Interests"),
    //         createSubHeading("Skills"),
    //         createSkillList(skills),
    //         createSubHeading("Achievements"),
    //         ...createAchievementsList(achievements),
    //         createSubHeading("Interests"),
    //         createInterests(
    //           "Programming, Technology, Music Production, Web Design, 3D Modelling, Dancing."
    //         ),
    //         createHeading("References"),
    //         new Paragraph(
    //           "Dr. Dean Mohamedally Director of Postgraduate Studies Department of Computer Science, University College London Malet Place, Bloomsbury, London WC1E d.mohamedally@ucl.ac.uk"
    //         ),
    //         new Paragraph("More references upon request"),
    //         new Paragraph({
    //           text: "This CV was generated in real-time based on my Linked-In profile from my personal website www.dolan.bio.",
    //           alignment: AlignmentType.CENTER,
    //         }),
    //       ],
    //     },
    //   ],
    // });
    // Packer.toBlob(document).then((blob) => {
    //   // Download the document
    //   saveAs(blob, "document.docx");
    // });
  };
  const createContactInfo = (profile, phoneNumber, profileUrl, email) => {
    return new Paragraph({
      alignment: AlignmentType.CENTER,
      children: [
        new TextRun(
          Object.keys(profile)
            .map((key, index) => {
              if (
                key === "name" ||
                key === "photo" ||
                key === "jobTitle" ||
                key === "showFields" ||
                key === "profile_image"
              ) {
                return ""; // Skip this field
              }
              return `${key}: ${profile[key]} |`;
            })
            .join(" ")
        ),
        // new TextRun(
        //   `Mobile: ${phoneNumber} | LinkedIn: ${profileUrl} | Email: ${email}`
        // ),
        // new TextRun({
        //   text: "Address: 58 Elm Avenue, Kent ME4 6ER, UK",
        //   break: 1,
        // }),
      ],
    });
  };

  const createHeading = (text) => {
    return new Paragraph({
      text: text,
      heading: HeadingLevel.HEADING_1,
      thematicBreak: true,
    });
  };

  const createSubHeading = (text) => {
    return new Paragraph({
      text: text,
      heading: HeadingLevel.HEADING_2,
    });
  };

  const createInstitutionHeader = (institutionName, dateText) => {
    return new Paragraph({
      tabStops: [
        {
          type: TabStopType.RIGHT,
          position: TabStopPosition.MAX,
        },
      ],
      children: [
        new TextRun({
          text: institutionName,
          bold: true,
        }),
        new TextRun({
          text: `\t${dateText}`,
          bold: true,
        }),
      ],
    });
  };

  const createRoleText = (roleText) => {
    return new Paragraph({
      children: [
        new TextRun({
          text: roleText,
          italics: true,
        }),
      ],
    });
  };

  const createBullet = (text) => {
    return new Paragraph({
      text: text,
      bullet: {
        level: 0,
      },
    });
  };

  const createSkillList = (skills) => {
    return new Paragraph({
      children: [
        new TextRun(skills.map((skill) => skill.name).join(", ") + "."),
      ],
    });
  };

  const createAchievementsList = (achievements) => {
    return achievements.map(
      (achievement) =>
        new Paragraph({
          text: achievement.name,
          bullet: {
            level: 0,
          },
        })
    );
  };

  const createInterests = (interests) => {
    return new Paragraph({
      children: [new TextRun(interests)],
    });
  };

  const splitParagraphIntoBullets = (text) => {
    return text.split("\n\n");
  };

  const createPositionDateText = (startDate, endDate, isCurrent) => {
    const startDateText =
      getMonthFromInt(startDate.month) + ". " + startDate.year;
    const endDateText = isCurrent
      ? "Present"
      : `${getMonthFromInt(endDate.month)}. ${endDate.year}`;

    return `${startDateText} - ${endDateText}`;
  };

  const getMonthFromInt = (value) => {
    switch (value) {
      case 1:
        return "Jan";
      case 2:
        return "Feb";
      case 3:
        return "Mar";
      case 4:
        return "Apr";
      case 5:
        return "May";
      case 6:
        return "Jun";
      case 7:
        return "Jul";
      case 8:
        return "Aug";
      case 9:
        return "Sept";
      case 10:
        return "Oct";
      case 11:
        return "Nov";
      case 12:
        return "Dec";
      default:
        return "N/A";
    }
  };

  return (
    <>
      <Modal
        show={props.show}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onEscapeKeyDown={handleHide}
        onHide={handleHide}
      >
        <Modal.Body>
          <img
            onClick={handleHide}
            src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/close.svg`}
            alt="closeicon"
            className="close"
          />
          <div className="container">
            {isProgress && isProgress ? (
              <div className=" text-align-center center-block">
                <div className=" mt-2">
                  <h3>
                    {isEmailSuccess ? "Check your inbox" : "Preparing the file"}
                  </h3>
                  <span>{progressValue}% Complete !</span>
                  <div className="my-4">
                    <ProgressBar now={progressValue} variant="success" />
                  </div>
                  {!isEmail && (
                    <span className="">
                      * If the download doesn't start automatically in a few
                      seconds, please{" "}
                      {downloadKey && downloadKey != "" ? (
                        <>
                          <span
                            style={{ color: "#009b61", cursor: "pointer" }}
                            onClick={handleDownload}
                          >
                            click here.
                          </span>
                        </>
                      ) : (
                        <>
                          <span
                            style={{ opacity: "0.5", cursor: "not-allowed" }}
                          >
                            click here.
                          </span>
                        </>
                      )}
                    </span>
                  )}
                </div>
              </div>
            ) : (
              <>
                <div className="text-center">
                  <h4 className="maintitle deletetitle">
                    Download your{" "}
                    {props && props.type == "resume"
                      ? "Resume"
                      : "Cover Letter"}
                  </h4>

                  {!isProgressError && (
                    <p className="titledesc deletedesc">
                      Please select the file format you’d like to download:
                    </p>
                  )}
                </div>
                {isProgressError && isProgressError ? (
                  <>
                    <p className="error text-center">
                      {previewResumeData && previewResumeData.error
                        ? previewResumeData.error
                        : previewResumeData &&
                          previewResumeData.data &&
                          previewResumeData.data.data &&
                          previewResumeData.data.data.message
                        ? "You need to be a Pro User to avail this service"
                        : coverDownload && coverDownload.error}
                    </p>
                  </>
                ) : (
                  <>
                    <div className="row justify-content-center text-align-center center-block">
                      <div className="col-md-12">
                        <button
                          className="btn primarybtn  w-75 mainborder delbtn bgsuccess text-white "
                          onClick={() => resumeDownload()}
                        >
                          Download as PDF
                        </button>
                      </div>
                    </div>

                    {/* <div className="row justify-content-center text-align-center center-block">
                      <div className="col-md-12">
                        <button
                          className="btn primarybtn  w-75 mainborder delbtn bgsuccess text-white "
                          onClick={() => resumeWordDownload()}
                        >
                          Download as Word
                        </button>
                      </div>
                    </div> */}

                    <div className="row justify-content-center text-align-center center-block">
                      <div className="col-md-12">
                        <button
                          onClick={() => resumeDownloadMail()}
                          className="btn primarybtn mainborder   p-14 w-75 delbtn"
                        >
                          Send PDF to your email
                        </button>
                      </div>
                    </div>
                  </>
                )}
              </>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default DownloadPopup;
